const toError = err => (err instanceof Error ? err : new Error(String(err)));

export default toError;
